/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { GenericInput, getGenericAction } from '@msdyn365-commerce-modules/retail-actions';
import { createObservableDataAction, IAction, IActionInput } from '@msdyn365-commerce/core';

export interface IRatingsReviewsState {
    filterKey: string;
}

export function createRatingsReviewsStateInput(result: IRatingsReviewsState): GenericInput<IRatingsReviewsState> {
    return new GenericInput<IRatingsReviewsState>('ratingsReviewsState', result, 'ratingsReviewsStateInput');
}

const createInternalRatingsReviewsStateInput = (): IActionInput => {
    return createRatingsReviewsStateInput({filterKey: '1;2;3;4;5'});
};

export default createObservableDataAction({
    action: <IAction<IRatingsReviewsState>>getGenericAction,
    input: createInternalRatingsReviewsStateInput
});
